import { z } from "zod";
import { CustomerStoryCardSchema } from "./customer-stories";
import { ExpertDetailsSchema } from "./expert-details";

export const PublicCustomerStoryDetailsSchema = CustomerStoryCardSchema.extend({
    expert: ExpertDetailsSchema,
});

export type PublicCustomerStoryDetails = z.infer<typeof PublicCustomerStoryDetailsSchema>;
